var exports = {
  "z": "x31de4314--3c70e4--root",
  "K": "x31de4314--3c70e4--icon",
};

module.exports = exports;
